export default __webpack_public_path__ + "static/britannica-b4cec8a0f6c592574bcaf261d815827c.png";